import React, {ReactNode, CSSProperties} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import Property from '@episerver/spa-core/Components/Property';
import TeaserBlockData from 'app/Models/Content/TeaserBlockData';

export default class TeaserBlock extends EpiComponent<TeaserBlockData> {
  public render(): null | ReactNode {
    return (
      <div style={this.getBlockStyles()} className={this.getClasses().join(' ')}>
        <div className='card h-100'>
          <Property context={this.getContext()} iContent={this.props.data} field='image' className='card-img-top' />
          <div className='card-body'>
            <h5 className='card-title'>
              <Property context={this.getContext()} iContent={this.props.data} field='heading' />
            </h5>
            <div className='card-text'>
              <Property context={this.getContext()} iContent={this.props.data} field='text' />
            </div>
          </div>
        </div>
      </div>
    );
  }
  protected getClasses(): Array<string> {
    let classes: Array<string> = ['teaserblock', 'h-100'];
    if (this.props.data.margin?.value) classes.push(this.props.data.margin.value);
    if (this.props.data.padding?.value) classes.push(this.props.data.padding.value);
    return classes;
  }
  protected getBlockStyles(): CSSProperties {
    return {
      backgroundColor: this.props.data.backgroundColor?.value || 'transparent',
      opacity: this.props.data.blockOpacity?.value || 1,
    };
  }
}
